@import "../../../css/_mixins.scss";

.container {
  display: flex;
  width: 100%;
  min-height: 75vh;
  text-align: center;
  overflow-x: hidden;
  box-sizing: border-box;

  @include small-desktop {
    flex-direction: column-reverse;
  }

  .donateMethod {
    position: relative;
    width: 400px;
    padding: 60px 50px;
    flex-shrink: 0;
    text-align: left;
    background-color: var(--concrete);
    box-sizing: border-box;

    @include small-desktop {
      width: 100%;
      padding: 40px 32px;
      text-align: center;
    }
    @include tablet {
      padding: 28px 20px;
    }
    @include mobile {
      padding: 20px 14px;
    }

    i {
      position: absolute;
      top: 35px;
      cursor: pointer;
      right: 20px;
      color: var(--azure);
      font-size: 24px;

      @include small-desktop {
        top: 16px;
        right: 16px;
      }
    }

    .donationLabel {
      font-size: 22px;
      line-height: 28px;
      font-weight: bold;
      color: var(--yellow);
      text-align: left;
      letter-spacing: -0.56px;

      @include small-desktop {
        text-align: center;
      }
      @include mobile {
        font-size: 18px;
        line-height: 1.3;
      }
    }

    .donationDescription {
      margin-top: 16px;
      color: var(--gray);
      text-align: left;
      font-size: 15px;
      line-height: 22px;
      letter-spacing: 0px;

      @include small-desktop {
        text-align: center;
      }
      @include mobile {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 32px 80px;
    box-sizing: border-box;

    @include small-desktop {
      width: 100%;
      padding: 32px 40px;
      margin-top: 0;
    }
    @include tablet {
      padding: 24px 20px;
    }
    @include mobile {
      padding: 16px 14px;
    }

    .title {
      text-align: center;
      color: var(--red);
      font-size: 50px;
      font-style: normal;
      font-weight: 700;
      line-height: 1.1;

      @include small-desktop {
        font-size: 42px;
      }
      @include tablet {
        font-size: 36px;
      }
      @include mobile {
        font-size: 28px;
      }
    }

    .description {
      margin-top: 22px;
      font-size: 20px;
      line-height: 1.4;
      color: var(--gray);
      font-weight: bold;
      text-align: center;
      letter-spacing: -0.7px;
      max-width: 600px;

      span {
        font-size: 24px;
        color: var(--red);
      }

      @include tablet {
        font-size: 18px;
        margin-top: 16px;
        span {
          font-size: 20px;
        }
      }
      @include mobile {
        font-size: 16px;
        span {
          font-size: 18px;
        }
      }
    }

    .lblMethod {
      margin-top: 28px;
      color: var(--gray);
      text-align: center;
      font-size: 22px;
      line-height: 1.3;
      letter-spacing: -0.62px;

      @include tablet {
        font-size: 18px;
        margin-top: 20px;
      }
    }

    .methodWrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 12px;
      margin-top: 20px;
      width: 100%;
      max-width: 560px;

      @include tablet {
        flex-direction: column;
        align-items: center;
        gap: 12px;
      }

      button {
        height: 50px;
        min-width: 220px;
        max-width: 100%;
        font-size: 20px;
        padding: 0 28px;

        i {
          margin-left: 16px;
        }

        @include tablet {
          width: 100%;
          max-width: 320px;
        }
      }
    }

    .text {
      font-size: 20px;
      color: var(--red);
      font-weight: bold;
      padding-top: 20px;

      @include tablet {
        font-size: 16px;
        padding-top: 12px;
      }
    }

    .spreadTheJoy {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      margin-top: 20px;
      color: var(--red);
      text-align: center;
      font-size: 22px;
      line-height: 1.3;
      flex-wrap: wrap;

      @include tablet {
        flex-direction: column;
        font-size: 18px;
      }
    }

    .sendDonor {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 10px;
      margin: 24px auto 0;
      max-width: 560px;
      width: 100%;
      padding: 0 12px;
      box-sizing: border-box;
      color: var(--yellow);
      text-align: left;
      font-size: 16px;
      line-height: 1.35;
      font-weight: bold;
      cursor: pointer;

      .sendDonorCheckbox {
        flex-shrink: 0;
        margin-top: 3px;
      }

      @include tablet {
        margin-top: 16px;
        font-size: 14px;
      }
    }

    .sentDonorEmail {
      text-align: center;
      font-size: 16px;
      line-height: 1.3;
      font-weight: bold;
      color: var(--yellow);
      margin-top: 24px;

      @include tablet {
        margin-top: 16px;
      }
    }

    .socialLinks {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      gap: 16px;
      margin-top: 32px;
      color: var(--red);
      text-align: center;
      font-size: 20px;
      line-height: 1;
      font-weight: bold;
      letter-spacing: -0.6px;

      @include tablet {
        margin-top: 20px;
        gap: 12px;
      }
      @include mobile {
        gap: 10px;
      }

      .btnShare {
        margin-left: 0;
        cursor: pointer;
        line-height: 0; // kill default vertical space around the icon

        i {
          font-size: 32px;

          @include tablet {
            font-size: 24px;
          }
          @include mobile {
            font-size: 20px;
          }
        }
      }
    }
  }
}
